<template>
      <!-- ======= SectionTwo Begins here =======  :pagination="{clickable: true}"-->
    <div class="sectioncontrol" data-aos="fade-up">
      <div class="sectiontwopurpose">{{ cvdesc }}</div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-3 sectiontwocol8"  v-for="photo in valuesphotos" :key="photo">
          <div class="card servicescards">
            <!-- <router-link :to="{path: cvlink}" class="cardref"> -->
            <img :src="`${myPicUrl}${photo.cardimage}`" class="card-img-top iconsize" alt="" data-aos="fade-up" data-aos-duration="100" data-aos-delay="100">
            <div class="card-body" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
              <h5 class="card-title" v-html="photo.carddesc"></h5>
              <p class="card-text"></p>
            </div>
          <!-- </router-link> -->
          </div>
        </div>
      </div>
      <!-- <div class="sectiontwolinkname"><a :href="cvlink">{{cvpurposevaluelinkname}}</a></div> -->
    </div>
</template>

<script>
require('@/globalDeclare.js');
export default {
    props: ['cvdesc', 'valuesphotos', 'cvpurposevaluelinkname', 'cvlink'],
data() {
  return {
    myPicUrl: ''
  }
},
 
mounted() {
  this.myPicUrl = myUrlPath
}
}
</script>

<style scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #003;
}
.sectioncontrol{
  opacity: .9;
  height: auto;
}
.sectiontwolinkname {
  text-align: right; 
  font-size: 19px;
  background: -webkit-linear-gradient(#003, maroon);
  -webkit-background-clip: text;

  font-weight: bold;
}
.sectiontwopurpose{
  text-align: center; 
  font-size: 26px;
  background: -webkit-linear-gradient(#003, maroon);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
}
.sectiontwo {
  background-color: #f9ebea;
  
 }
.servicescards {
  background-color: #003;
  color: white;
  text-align: center;
}
.iconsize {
  width: 100px;
}
.card-title{
  color: white;
  text-decoration: none;
}
.cardref{
  text-decoration: none;
  cursor: default;
}

@media (min-width: 390px) and (max-width: 550px) {
  .sectioncontrol{
    padding-right: 20px;
    padding-left: 20px;
  }
}
/*===================MEDIA SCREENS TAMPLATES===============*/
 /* Extra small devices (phones, 600px and down) */
 @media only screen and (max-width: 600px) {
  .sectioncontrol{
    padding-right: 20px;
    padding-left: 20px;
  }
  .card {
    margin-top: 40px;
  }
 }

 /* Small devices (portrait tablets and large phones, 600px and up) */
 @media only screen and (min-width: 600px) {
  .sectioncontrol{
    padding-right: 20px;
    padding-left: 20px;
  }
  .card {
    margin-top: 40px;
  }
 }
 
 /* Medium devices (landscape tablets, 768px and up) */
 @media only screen and (min-width: 768px) {
  
 }

 /* Large devices (laptops/desktops, 992px and up) */
 @media only screen and (min-width: 992px) {

 }
 
 /* Extra large devices (large laptops and desktops, 1200px and up) */
 @media only screen and (min-width: 1200px) {
  .sectioncontrol{
    padding-right: 200px;
    padding-left: 200px;
  }
  .card{

    margin-top: 70px;
  }
 } 
</style>